import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import Overlay from "../../../SharedComponents/Overlay";
import CreateCandidatesList from "./CreateCandidatesList";
import { ChangeIsUpdateOperation, ShowUpsertCandidateModal } from "../Store";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { getCandidatesByCompanyId } from "../Store/Thunk";
import { getPositionsByCompanyId } from "../../CreatePosition/Store/Thunk";
import UpsertCandidateModal from "./UpsertCandidateModal";
import ScrollableCard from "../../../SharedComponents/ScrollableCard";
import IconSvg from "../../../SharedComponents/IconSvg";
import { getCompanyCreateProjectData } from "../../Project/Store/Thunk";
import { Card } from "react-bootstrap";

export default function CreateCandidate() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.createCandidate.isLoading);
  const candidateList = useSelector((state) => state.createCandidate.candidateList);
  const positionList = useSelector((state) => state.createPosition.positionList);
  const companyId = useSelector((state) => state.auth.user.companyUser.company.companyId);

  const [searchInput, setSearchInput] = useState("");
  const [selectedCandidate, setSelectedCandidate] = useState(null);

  useEffect(() => {
    dispatch(getPositionsByCompanyId({ id: companyId }));
    dispatch(getCandidatesByCompanyId({ companyId: companyId }));
    dispatch(getCompanyCreateProjectData());
  }, [companyId]);

  const CreateCandidate = () => {
    dispatch(ShowUpsertCandidateModal({ upsertCandidateModalIsShown: true }));
    dispatch(ChangeIsUpdateOperation({ isUpdateOperation: false }));
  };

  const FilteredCandidateList = () => {
    return candidateList.filter((candidate) => {
      const matchesName = searchInput
        ? candidate.candidateName.toLowerCase().includes(searchInput.toLowerCase())
        : true;
      const matchesEmail = searchInput ? candidate.email.toLowerCase().includes(searchInput.toLowerCase()) : true;

      return matchesName || matchesEmail;
    });
  };

  return (
    <>
      <Form
        onSubmit={(e) => {
          e.preventDefault();
        }}
      >
        <Row className="justify-content-between mx-0 ">
          <Col xs={12} sm={true}>
            <Form.Control
              placeholder={t("searchCandidateLabel")}
              style={{ height: "46px" }}
              className="default-text-input white-bg text-color-gray-light"
              onChange={(e) => {
                setSearchInput(e.target.value);
              }}
            />
          </Col>
          <Col xs={12} sm="auto" className="mt-sm-0 mt-2">
            <Button
              className="button secondary w-100"
              onClick={() => {
                CreateCandidate();
              }}
            >
              <Row>
                <Col xs="auto" className="align-content-center">
                  <IconSvg icon="plusV2" height={22} width={22} />
                </Col>
                <Col xs="auto" className="text-20 fw-medium">
                  {t("createNewCandidateButtonLabel")}
                </Col>
              </Row>
            </Button>
          </Col>
        </Row>
      </Form>

      {isLoading && <Overlay />}

      <ScrollableCard bottom={20}>
        <Row className={"mx-0"}>
          <Col>
            <CreateCandidatesList
              candidatesList={FilteredCandidateList()}
              setSelectedCandidate={setSelectedCandidate}
            />

            {FilteredCandidateList().length === 0 && (
              <Card className="default-card unavailable">
                <div className="d-flex flex-column p-3 " style={{ height: "155px" }}>
                  <Row className={"h-100"}>
                    <Col className="text-center align-content-center text-32 text-color-gray-light fw-medium">
                      {searchInput ? t("noCandidatesFound") : t("noCandidatesAddedYet")}
                    </Col>
                  </Row>
                </div>
              </Card>
            )}
          </Col>
        </Row>
      </ScrollableCard>

      <UpsertCandidateModal
        positionList={positionList}
        selectedCandidate={selectedCandidate}
        setSelectedCandidate={setSelectedCandidate}
      />
    </>
  );
}
